import { SDKOptions } from "../../types/options";

export type DemographicsCategory =
  | "income"
  | "population"
  | "housing"
  | "household"
  | "education"
  | "commute"
  | "languages";

export type Options = {
  lat?: number;
  lng?: number;
  title?: boolean | string;
  defaultTab?: DemographicsCategory;
};

export type LocalDemographicsProps = SDKOptions<
  Options,
  {
    options: Options | undefined;
  }
>;

export enum TrackingPipelineEvents {
  SDK_VIEWED = "LD-Viewed",
  TAB_CLICKED = "LD-Tab-Clicked",
}

// Why are these named differently?
// https://docs.mixpanel.com/docs/data-structure/events-and-properties#name-events-and-properties-consistently
export enum AnalyticsEvents {
  SDK_VIEWED = "sdk_viewed",
  CATEGORY_SELECTED = "category_selected",
}
